/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import CardsMeetingBtn from './CardsMeetingBtn';

/**
 * CardsMeetingBtn module exports
 */
export { CardsMeetingBtn as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CardsMeetingsBtn/index.js